import type { IconType } from "react-icons"

const FILL_EXPORT = /^Pi[A-Za-z0-9]+Fill$/
const WEIGHT_SUFFIX = /(Bold|Light|Thin|Duotone|Fill)$/

function toPascalSegments(raw: string): string {
  return raw
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("")
}

/** Canonical react-icons/pi export name, always the filled weight (e.g. PiHouseFill). */
export function normalizePhosphorFillName(raw: unknown): string {
  if (typeof raw !== "string") return ""
  let s = raw.trim()
  if (!s) return ""
  s = s.replace(/^react-icons\/pi\//i, "")
  if (s.startsWith("pi") && !s.startsWith("Pi")) {
    s = `Pi${s.slice(2)}`
  }
  if (!s.startsWith("Pi")) {
    s = `Pi${toPascalSegments(s)}`
  }
  s = s.replace(WEIGHT_SUFFIX, "")
  if (!s.startsWith("Pi") || s.length < 3) return ""
  s = `${s}Fill`
  return FILL_EXPORT.test(s) ? s : ""
}

export function phosphorFillLabel(exportName: string): string {
  return exportName.replace(/^Pi/, "").replace(/Fill$/, "").replace(/([a-z])([A-Z])/g, "$1 $2")
}

let piModulePromise: Promise<Record<string, IconType>> | null = null

export function loadPhosphorIcons(): Promise<Record<string, IconType>> {
  if (!piModulePromise) {
    piModulePromise = import("react-icons/pi").then((mod) => mod as unknown as Record<string, IconType>)
  }
  return piModulePromise
}

export function getPhosphorFillIcon(
  icons: Record<string, IconType> | null,
  raw: unknown
): IconType | null {
  const name = normalizePhosphorFillName(raw)
  if (!name || !icons) return null
  const icon = icons[name]
  return typeof icon === "function" ? icon : null
}

export function listPhosphorFillIcons(icons: Record<string, IconType>): Array<{ name: string; Icon: IconType }> {
  return Object.keys(icons)
    .filter((name) => FILL_EXPORT.test(name) && typeof icons[name] === "function")
    .sort((a, b) => a.localeCompare(b))
    .map((name) => ({ name, Icon: icons[name] }))
}
